import React, { useEffect, useRef, useState } from 'react'
import * as gtUtil from "../../../core/utility";
import InstagramIcon from "../../../components/icons/instagram-icon";
import { BrandDataService } from "../../../core/services/brand-data.service";
import { Launch, Search, TrendingUp } from "@mui/icons-material";
import InstagramIcon1 from '../../../components/icons/instagram-icon1';
import YouTube from '@mui/icons-material/YouTube';
import { DetailedInfluencerAnalyticsBrandOrganic } from './detailed-influencer-analytics';
import { connect } from "react-redux";
import { Loading } from "../../../redux/action";
import { BrandPulseProfileCard } from './brand-pulse-profile-card';
import "./brand-data.scss";
import { MetricsCard } from './metrics-card';
import { FollowersGrowthChart } from './followers-growth-chart';
import { ContentTypeChart } from './content-type-chart';
import { InfluencerGrid } from './influencer-grid';
import { PostErChart } from './post-er-chart';
import { TopInfluencer } from './topInfluencer';
import { ComparisionTable } from './comparsion-table';
import { EngagedInfluencers } from './engaged-influencers';
import { RolesService } from '../../../core/services/roles.service';
import { LocalService } from '../../../core/services/local.service';
import { useNavigate, useParams } from 'react-router-dom';
import { EngagedInfluencerTable } from './engaged-influencer-table';
import { FormControl, Grid, InputLabel, MenuItem, Select, Skeleton, Tooltip as MuiTooltip } from '@mui/material';
import { ColumnChart, PieChart } from '../../../components/charts';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3d from 'highcharts/highcharts-3d'
import WordCloudComponent from './brandPulseWordCloud';
import { CommentsTab } from './comments-tab';
import { EmvChart } from './emv-chart';
import { EmvROI } from './emv_roi_chart';
import { BrandErVerticalChart } from './brand-er-vertical-chart';
import { DetailedInfluencerAnalyticsPaid } from './detailed-influencer-analytics-paid';
import { DetailedInfluencerAnalyticsBrand } from './detailed-influencer-analytics-brand';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { EngagedInfluencersAmount } from './engaged-influencer-amount';
import MaterialSymbol from '../../../components/icons/material-symbol';
import { DetailedAnalyticsBrandPulse } from '../../common/analytics/detailed-analytics-brand-pulse';
import {DetailedAnalyticsBrandPulseNew} from '../../common/analytics/detailed-analytics-new/src';
import { Card } from '../../../components';
import { Avatar, AvatarFallback, AvatarImage } from '../../common/analytics/detailed-analytics-new/src/components/ui/avatar';
import { Badge } from '../../common/analytics/detailed-analytics-new/src/components/ui/badge';
import { BrandPulseMetricCard } from './components/BrandPulseMetricCard';
import { Calendar, DollarSign, Eye, Heart, MessageCircle } from 'lucide-react';
import { DualMetricCard } from './components/DualMetricCard';
import { Separator } from '@radix-ui/react-dropdown-menu';
import { ChartCard } from './components/ChartCard';
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { PaidVsOrganicChart } from './components/PaidVsOrganicChart';
import { SentimentAnalysis } from './components/SentimentAnalysis';
import { TopHashtags } from './components/TopHashtags';
import { TopPerformersRow } from './components/TopPerformersRow';
import { InfluencerEngagementSummary } from './components/InfluencerEngagementSummary';
import { EngagementSnapshotTabs } from './components/EngagementSnapshotTabs';
import { SimilarAccounts } from './components/SimilarAccounts';
import { CompetitionTable } from './components/CompetitionTable';
import { BrandPulseCampaignList } from './brand-pulse-campaign-list';
import CreateBrandPulseCampaignPopup from './create-brand-pulse-campaign-popup';

const methods = new gtUtil.Methods()
const rolesService = new RolesService();
const localService: LocalService = new LocalService();
const brandDataService: BrandDataService = new BrandDataService();
Highcharts3d(Highcharts);

interface Props {
  UserReducer: any;
  loading: (data: boolean) => void;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface InfluencerTableData {
  paid: any[];
  paid_videos: any[];
  paid_images: any[];
  brand_organic: any[];
  brand_organic_videos: any[];
  brand_organic_images: any[];
  brand: any[];
  brand_videos: any[];
  brand_images: any[];
  total: string;
  total_pages: string;
  [key: string]: any;
}

type AccordionType = "paid" | "brand_organic" | "brand" | undefined;

const influencerTypeRange:any = {
  Nano: "1K - 10K",
  Micro: "10K - 50K",
  "Micro Plus": "50K - 100K",
  Macro: "100K - 500K",
  "Macro Plus": "500K - 1M",
  Mega: "1M - 5M",
  "Mega Plus": "5M+",
}

// Generic rectangular skeleton placeholder used for Brand Pulse dashboard
// sections while their data is still being fetched, so the page shows a loading
// state per-section instead of empty/"No data found" blocks.
const SectionSkeleton: React.FC<{ height?: number; className?: string }> = ({ height = 300, className = 'mb-3' }) => (
  <Skeleton variant="rectangular" height={height} className={className} sx={{ borderRadius: '8px' }} />
);

const BrandPulse: React.FC<Props> = ({ loading, ...props }: Props) => {
  const { ref_id, username } = useParams<{ ref_id: string; username: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [dataApi1, setDataApi1] = useState<any>([]);
  const [dataApi2, setDataApi2] = useState<any>([]);
  const [dataApi3, setDataApi3] = useState<any>([]);
  const [dataApi4, setDataApi4] = useState<any>([]);
  const [dataApi5, setDataApi5] = useState<any>([]);


  const [searchValue, setSearchValue] = useState("")
  const [searchList, setSearchList] = useState<any>([]);
  const [brandImage, setBrandImage] = useState("")
  const [brandRefId, setBrandRefId] = useState(0);
  const [detailedInfluencer, setDetailedInfluencer] = useState("")
  const [profileData, setProfileData] = useState("");
  const [isSelected, setIsSelected] = useState(false)
  const [userStatus, setUserStatus] = useState(false)
  const [postFrequency, setPostFrequency] = useState("")
  const [profileEr, setProfileEr] = useState<any>([]);
  const [paidFrequency, setPaidFrequency] = useState<any>([]);
  const [organicFrequency, setOrganicFrequency] = useState<any>([]);
  const [subsGrowthStockChartData, setSubsGrowthStockChartData] = useState<any[]>([]);
  const [contentTypeChart, setContentTypeChart] = useState<any[]>([])
  const [influencerData, setinfluencerData] = useState<any[]>([]);
  const [postErChart, setPostErChart] = useState<any[]>([]);
  const [topPaidInfluencer, setTopPaidInfluencer] = useState<any[]>([]);
  const [topOrganicInfluencer, setTopOrganicInfluencer] = useState<any[]>([]);
  const [topCompetitors, setTopCompetitors] = useState<any[]>([]);
  const [comparisionData, setComparisionData] = useState<any[]>([]);
  const [influencerDetails, setInfluencerDetails] = useState<any[]>([]);
  const [paidOrganicER, setPaidOrganicER] = useState<any[]>([]);
  const [worldCloud, setWorldCloud] = useState<any[]>([]);
  const [paidHashtags, setPaidHashtags] = useState<any[]>([]);
  const [organicHashtags, setOrganicHashtags] = useState<any[]>([]);
  const [paidComments, setPaidComments] = useState<any[]>([]);
  const [organicComments, setOrganicComments] = useState<any[]>([]);
  const [totalCommentsCount, setTotalCommentsCount] = useState<any[]>([]);
  const [emvGraph, setEmvGraph] = useState<any[]>([]);
  const [amountGraph, setAmountGraph] = useState<any[]>([]);
  const [brandData, setBrandData] = useState<any[]>([]);
  const [paidOrganicImageVideoER,setPaidOrganicImageVideoER] = useState<any[]>([]);
  const [influencerEngagementSummary,setInfluencerEngagementSummary] = useState<any[]>([]);
  const [influencerEngagementSummaryPaid,setInfluencerEngagementSummaryPaid] = useState<any[]>([]);
  const [keyInsightsPaid,setKeyInsightsPaid] = useState<any[]>([]);
  
  const [influencerEngagementGraphPaid,setInfluencerEngagementGraphPaid] = useState<any[]>([]);
  const [influencerEngagementGraphOrganic,setInfluencerEngagementGraphOragnic] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [dayRange, setDayRange] = useState<RangeType>("180");
  const [searchExpand, setSearchExpand] = useState(false)
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [amount, setAmount] = useState("")
  const [loadingAccordion, setLoadingAccordion] = useState(false);
  const [selectedTab, setSelectedTab] = useState<"brands" | "influencer">("influencer");
  const [selectedInnerTab, setSelectedInnerTab] = useState<"image" | "video">("video");
  // For Getting Brand Data
  const [profileLoading, setProfileLoading] = useState(false)
  // True for the whole initial Brand Pulse load (profile + all dashboard
  // sections). Drives per-section skeletons so every not-yet-loaded section shows
  // a skeleton from the start and is replaced by real content as soon as its own
  // data arrives.
  const [brandPulseLoading, setBrandPulseLoading] = useState(false)
  
  const [hasSearched, setHasSearched] = useState(false)
  const [dataApi6, setDataApi6] = useState<any>([]);
  const [profileUpdatedAt,setProfileUpdatedAt] = useState(0);
  const [linkedCampaignId, setLinkedCampaignId] = useState([]);
  const [openCreateCampaign, setOpenCreateCampaign] = useState(false);

  const [detailedInfluencerTableData, setDetailedInfluencerTableData] = useState<InfluencerTableData>({
    paid: [],
    paid_videos: [],
    paid_images: [],
    brand_organic: [],
    brand_organic_videos: [],
    brand_organic_images: [],
    brand: [],
    brand_videos: [],
    brand_images: [],
    total: "",
    total_pages: "",
  });

  const [activeAccordion, setActiveAccordion] = useState<AccordionType>("paid");
  const navigate = useNavigate();
  


  useEffect(() => {
    if (ref_id && username) {
      handleBrandData(ref_id)

      // ✅ Example: call an API to fetch influencer details
      // fetchInfluencerData(ref_id, username);
    }
  }, [ref_id, username]);
  


  function getTimeDifference(givenDateStr:any) {
    const givenDate:any = new Date(givenDateStr);
    const now :any= new Date();
    let diffMs = Math.abs(now - givenDate);
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    diffMs %= (1000 * 60 * 60 * 24);
    return  days ;
  }
  
  const checkAccessFunction = async () => {
    try {
      const res = await rolesService.checkAccess({ access_roles: ["brand_pulse"], user_id: props?.UserReducer?.user_id })
      if (res.data.rows.length > 0) {
        setUserStatus(true);
      }
      else {
        localService.toastify("You are not allowed to access", "error", 1000);
        navigate(`/`);
      }
    }
    catch (error) {
      console.error('Error fetching getAdminDashData:', error);

    }
  }
  // For Searching Items.......

  const handleSearchBar = async ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const inputValue = target.value.toLowerCase();
      setSearchValue(inputValue);
      if (!inputValue || inputValue.length < 3) {
        setSearchList([]);
        return;
      }
      const response = await brandDataService.getBrandSearch(inputValue);
      if (response.status == gtUtil.Constants.SUCCESS) {
        setSearchList(response.data.rows);
        setBrandImage(response.data.rows)
      }
    }
    catch (error) {
      console.log(`getBrandSearch error :: ${JSON.stringify(error)}`);
    }
  };

  // For Rendring Profile List Items....................................

  const renderProfileListItem = (item: any) => {
    return <>
      <li className="insta-search-list" key={item?.ref_id}>
        <div className="col">
          <div className="d-flex flex-wrap align-items-center" onClick={() => handleSelectItem(item)}>
            <span onClick={() => handleSelectItem(item)}>
              {item?.platform === 'instagram' ? <InstagramIcon1 width={25} /> : <YouTube fontSize="small" style={{ color: 'red' }} />}
            </span>
            <strong>
              <span className="insta-username insta-search-username mx-2" onClick={() => handleSelectItem(item)}>
                {item?.platform === 'instagram' ? item?.username : item?.title}
              </span>
            </strong>
            <span className="ms-auto" style={{ color: 'black' }} onClick={() => handleSelectItem(item)}>
              <Launch fontSize="small" sx={{ height: 'auto' }} />
            </span>
          </div>
        </div>
        <p>
          <span style={{ textDecoration: 'none', color: 'black' }} onClick={() => handleSelectItem(item)}>
            {item.platform === 'instagram' ? item?.insta_name : item?.title}
          </span>
        </p>
      </li>
    </>

  };
  const handleSelectItem = (item: any) => {
    const displayName = item?.platform === 'instagram' ? item?.username : item?.title;
    setSearchValue(displayName); // ✅ fill the input field
    setIsSelected(false);        // ✅ hide suggestion list
    handleBrandData(item?.ref_id); // ✅ trigger main action
  };


  const [EnggSnapshotPaidData, setEnggSnapshotPaidData] = useState()
  const [EnggSnapshotOrganicData, setEnggSnapshotOrganicData] = useState()
  const [EnggSnapshotBrandData, setEnggSnapshotBrandData] = useState()
  const [EnggSnapshotData, setEnggSnapshotData] = useState()

  // Re-reads just the linked campaign list after the Create Campaign CTA makes a new brand
  // pulse campaign. This is what flips the Campaign Tracking tab from disabled to enabled,
  // without needing a page reload.
  const refreshLinkedCampaigns = async (selectedRefId: any) => {
    try {
      const response = await brandDataService.profileCard(selectedRefId);
      if (response.status === gtUtil.Constants.SUCCESS) {
        setLinkedCampaignId(response.data?.rows?.linked_campaign_id || []);
      }
    } catch (error) {
      console.error('refreshLinkedCampaigns :: ', error);
    }
  };

  const handleBrandData = async (selectedRefId: any) => {
    try {
      // loading(true);
      setIsSelected(false);
      setProfileLoading(true)
      setBrandPulseLoading(true) // show per-section skeletons for the whole initial load
      setHasSearched(true);
      const response = await brandDataService.profileCard(selectedRefId);
      if (response.status == gtUtil.Constants.SUCCESS) {
        // OLD: only assigned when the new brand HAS campaigns, so switching from a brand with
        // campaigns to one without left the previous brand's list in state - which wrongly
        // enabled Campaign Tracking and hid the Create Campaign shortcut for the new brand.
        // if (response.data?.rows?.linked_campaign_id && response.data?.rows?.linked_campaign_id.length > 0) setLinkedCampaignId(response.data.rows.linked_campaign_id);
        setLinkedCampaignId(response.data?.rows?.linked_campaign_id || []);
        loading(false);
        setProfileLoading(false)
        setBrandRefId(selectedRefId);
        setProfileData(response.data.rows.brand_profile)
        setDataApi1(response.data.rows);
        setProfileData(response.data.rows.brand_profile);
        const time_duration = getTimeDifference(response.data.rows.brand_profile[0].updated_at);
        setProfileUpdatedAt(time_duration);
        const response3 = await brandDataService.topData(selectedRefId);
        if (response3.status == gtUtil.Constants.SUCCESS) {
          setTopPaidInfluencer(response3.data.rows.top_paid_influencers)
          setTopOrganicInfluencer(response3.data.rows.top_organic_influencers)
          setTopCompetitors(response3.data.rows.top_competitors)
          setDataApi3(response3.data.rows)
        }
        
        await handleDayRange(selectedRefId,180)
        const response6 = await brandDataService.getSimailarBrandInfluencers(selectedRefId);
        if (response6.status == gtUtil.Constants.SUCCESS) {
          setinfluencerData(response6.data.rows.similar_influencers)
          setBrandData(response6.data.rows.similar_brands)
        }
        // const day_range:any = profileUpdatedAt ? Number(dayRange) + profileUpdatedAt : Number(dayRange) + 0

      }
    } catch (error) {
      console.log(`Brand Pulse Api :: ${JSON.stringify(error)}`);
    } finally {
      loading(false);
      setBrandPulseLoading(false);
    }
  }

  const [loadingMetricCard, setLoadingMetricCard] = useState(false);
  const [loadingGrowthChart, setLoadingGrowthChart] = useState(false);
  const [loadingAmountEmvGraph, setLoadingAmountEmvGraph] = useState(false);
  const [loadingComments, setLoadingComments] = useState(false);
  const [loadingHashtags, setLoadingHashtags] = useState(false);
  const [loadingEngagementSummary, setLoadingEngagementSummary] = useState(false);
  const [loadingEngagementGraph, setLoadingEngagementGraph] = useState(false);
  const [loadingSnapshot, setLoadingSnapshot] = useState(false);
  const [loadingComparison, setLoadingComparison] = useState(false);
  const handleDayRange = async (selectedRefId: any, range: any) => {
    let day_range: any = profileUpdatedAt ? Number(range) + profileUpdatedAt : Number(range) + 0;
  
    // SECTION 1: Metric Card
    setLoadingMetricCard(true);
    try {
      const response2 = await brandDataService.metricCard(selectedRefId, day_range);
      if (response2.status === gtUtil.Constants.SUCCESS) {
        const data = response2.data.rows;
        if (data.brand_post_frequency_data.length > 0) {
          setPostFrequency(data.brand_post_frequency_data[0]);
          setPaidFrequency(data.brand_post_frequency_data[0]["paid_post_value"]);
          setOrganicFrequency(data.brand_post_frequency_data[0]["brand_organic_post_value"]);
          setPaidOrganicImageVideoER(data.paid_organic_image_video_er);
          setPaidOrganicER(data.paid_organic_er);
        }
        setProfileEr(data.profile_er);
        setAmount(data.amount);
        setDataApi2(data);
      }
    } finally {
      setLoadingMetricCard(false);
    }
  
    // SECTION 2: Growth Chart
    setLoadingGrowthChart(true);
    try {
      const response9 = await brandDataService.growthChart(selectedRefId, day_range);
      if (response9.status === gtUtil.Constants.SUCCESS) {
        const data = response9.data.rows;
        if (Array.isArray(data.subscriber_growth_chart)) {
          setSubsGrowthStockChartData(data.subscriber_growth_chart);
        }
        setContentTypeChart(data.content_chart);
        setPostErChart(data.er_chart);
        setDataApi6(data);
      }
    } finally {
      setLoadingGrowthChart(false);
    }
  
    // SECTION 3: Amount & EMV Graph
    setLoadingAmountEmvGraph(true);
    try {
      const response7 = await brandDataService.amountEMVGraph(selectedRefId, day_range);
      if (response7.status === gtUtil.Constants.SUCCESS) {
        const data = response7.data.rows;
        setAmountGraph(data.amount_graph);
        setEmvGraph(data.emv_graph);
      }
    } finally {
      setLoadingAmountEmvGraph(false);
    }
  
    // SECTION 4: Comments
    setLoadingComments(true);
    try {
      const response4 = await brandDataService.getComments(selectedRefId, day_range);
      if (response4.status === gtUtil.Constants.SUCCESS) {
        const data = response4.data.rows;
        setTotalCommentsCount(data.totalCommentsCount);
        setPaidComments(data.paid_comments);
        setOrganicComments(data.organic_comments);
        setDataApi4(data);
      }
    } finally {
      setLoadingComments(false);
    }
  
    // SECTION 5: Hashtags
    setLoadingHashtags(true);
    try {
      const response5 = await brandDataService.hashtags(selectedRefId, day_range);
      if (response5.status === gtUtil.Constants.SUCCESS) {
        const data = response5.data.rows;
        setPaidHashtags(data.paid_hashtags);
        setOrganicHashtags(data.organic_hashtags);
        setDataApi5(data);
      }
    } finally {
      setLoadingHashtags(false);
    }
  
    // SECTION 6: Engagement Summary
    setLoadingEngagementSummary(true);
    try {
      const response8 = await brandDataService.influencerEngagementSummary(selectedRefId, day_range);
      if (response8.status === gtUtil.Constants.SUCCESS) {
        const data = response8.data.rows;
        setInfluencerEngagementSummaryPaid(data.influencer_enagagement_summary_paid);
        setKeyInsightsPaid(data.key_insights_paid);
      }
    } finally {
      setLoadingEngagementSummary(false);
    }
  
    // SECTION 7: Engagement Graph
    setLoadingEngagementGraph(true);
    try {
      const response10 = await brandDataService.influencerEngagementGraph(selectedRefId, day_range);
      if (response10.status === gtUtil.Constants.SUCCESS) {
        const data = response10.data.rows;
        setInfluencerEngagementGraphPaid(data.influencer_enagagement_graph_paid);
        setInfluencerEngagementGraphOragnic(data.influencer_enagagement_graph_paid);
      }
    } finally {
      setLoadingEngagementGraph(false);
    }
  
    // SECTION 8: Snapshot Summary
    setLoadingSnapshot(true);
    try {
      const response11 = await brandDataService.snapshotSummary(selectedRefId, "paid", day_range);
      if (response11.status === gtUtil.Constants.SUCCESS) {
        setEnggSnapshotData(response11?.data?.rows?.[0] || {});
      }
    } finally {
      setLoadingSnapshot(false);
    }
  
    // SECTION 9: Brand Comparison
    setLoadingComparison(true);
    try {
      const res = await brandDataService.compareBrandData(selectedRefId, day_range);
      if (res.status === gtUtil.Constants.SUCCESS) {
        setComparisionData(res.data.rows);
      }
    } finally {
      setLoadingComparison(false);
    }
  
    // Fire-and-forget call (no loading state needed unless UI depends on it)
    await influencerBrandData(selectedRefId, selectedTab, "image", "paid", day_range);
    await influencerBrandData(selectedRefId, "influencer", "video", "paid", day_range);
  };
  
   

  
  type RangeType = "7" | "15" | "30" | "90" |  "180" | "1000";
  const influencerBrandData = async (
    selectedRefId: any,
    media_type: "influencer" | "brands",
    type: "image" | "video",
    paid_type?: "paid" | "brand_organic" | "brand",
    day_range?: RangeType,
  ) => {
    setLoadingAccordion(true);
    try {
      const range:any = profileUpdatedAt ? Number(day_range) + profileUpdatedAt : Number(day_range) + 0

      const response = await brandDataService.getEngagedInfluencer(
        selectedRefId,
        media_type,
        type,
        paid_type,
        range
      );
  
      // check for error, missing data, or empty rows
      if (
        response.status !== gtUtil.Constants.SUCCESS ||
        !response.data ||
        !response.data.rows ||
        response.data.rows.length === 0
      ) {
        if (paid_type) {
          setDetailedInfluencerTableData(prev => ({
            ...prev,
            [paid_type]: [],
            [`${paid_type}_videos`]: [],
            [`${paid_type}_images`]: [],
            total: "0",           // ✅ as string
            total_pages: "0",     // ✅ as string
            [`${paid_type}_noData`]: true,
          }));
        }
        return;
      }
  
      // success and has data
      if (paid_type) {
        setBrandRefId(selectedRefId);
        const videoContent = response.data.rows.filter(
          (item: any) =>
            item.content_type?.toLowerCase() === "reel" ||
            item.content_type?.toLowerCase() === "video"
        );
  
        const imageContent = response.data.rows.filter(
          (item: any) =>
            item.content_type?.toLowerCase() !== "reel" &&
            item.content_type?.toLowerCase() !== "video"
        );
  
        setDetailedInfluencerTableData(prev => ({
          ...prev,
          [paid_type]: response.data.rows,
          [`${paid_type}_videos`]: videoContent,
          [`${paid_type}_images`]: imageContent,
          total: String(response.data.total),        // ✅ convert to string
          total_pages: String(response.data.total_pages), // ✅ convert to string
          [`${paid_type}_noData`]: false,
        }));
      }
        const response12 = await brandDataService.snapshotSummary(selectedRefId,paid_type,range);
        if (response12.status == gtUtil.Constants.SUCCESS) {
          setEnggSnapshotData(response12?.data?.rows?.[0] || {})
        }

    } catch (error) {
      console.log(`Brand Pulse Api :: ${JSON.stringify(error)}`);
    } finally {
      loading(false);
      setLoadingAccordion(false);
    }
  };
  


  const handleSelect = (eventKey: any) => {
  };

  const totalFollowers = influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.influencer_count, 0);
  const totalPosts =  influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.record_count, 0);
  const totalAmountSpent = influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.total_amount, 0);

  const totalEMV = influencerEngagementSummaryPaid.length > 0 &&  influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.emv_total, 0);

  const totalER =  influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.average_er, 0);

  const [isDurationLoading, setIsDurationLoading] = useState(false);
  const handleChange = (event:any) => {
    const selectedRange = event.target.value;
    setDayRange(selectedRange);
    handleDayRange(brandRefId, selectedRange);
  };

  const handleTabSelect = async (key: any, innerKey: any) => {
    setSelectedTab(key);
    setSelectedInnerTab(innerKey);
  
    const mediaType = key === "influencer" ? "influencer" : "brands";
    const contentType = innerKey === 'video' ? "video" : "image";
    if (activeAccordion !== null) {
      try {
        await influencerBrandData(brandRefId, mediaType, contentType, activeAccordion, dayRange);
      } catch (error) {
        console.error("Failed to fetch influencer brand data:", error);
      }
    }
  };
  const searchRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsSelected(false); 
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleSearchExpand = () =>{
    setSearchExpand(prev => !prev)
  }
 

// useEffect(() => {
//   const handleScroll = () => {
//     if (window.scrollY > 100) {
//       setShowSearchBar(false);
//     } else {
//       setShowSearchBar(true);
//     }
//   };

//   window.addEventListener('scroll', handleScroll);
//   return () => window.removeEventListener('scroll', handleScroll);
// }, []);




const getInfluencerTypesWithRange = (items: any[]) => {
  return items
    .map((item:any) => {
      const range:any = influencerTypeRange[item.influencer_type] || "";
      return `${item.influencer_type} (${range})`;
    })
    .join(" & ");
};

const metricConfig = {
  total_amount: {
    icon: "💰",
    label: "Maximum Spend",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers received the highest investment - <strong>₹{methods.convertExactNumber(value)}</strong></>
  },
  record_count: {
    icon: "🧑‍💼",
    label: "Most Active Contributors",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers topped the volume with <strong>{methods.convertExactNumber(value)}</strong> posts.</>
  },
  average_er: {
    icon: "🔥",
    label: "Highest Engagement Rate",
    template: (types:any, value:any) =>
      <> <strong>{types}</strong> Influencers lead with a <strong>{value.toFixed(2)}%</strong> ER.</>
  },
  emv_total: {
    icon: "💎",
    label: "Top Earned Media Value (EMV)",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers generated the highest EMV at <strong>₹{methods.convertExactNumber(value)}</strong></>
  },
  followers_total: {
    icon: "👥",
    label: "Top Reach",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers reached the highest follower base – <strong>{methods.convertExactNumber(value)}</strong></>
  }
};
const [addCompetitorToTable, setAddCompetitorToTable] = useState()
const [errorMsg, setErrorMsg] = useState<string | null>(null);
const handleAddCompetitorComparison = async (selectedRefId: any) => {
  const existingRefIds = new Set(comparisionData.map(item => item.ref_id.toString()));
  if (existingRefIds.has(selectedRefId.toString())) {
    setErrorMsg("This brand is already added to the comparison.");
    return;
  }

  if (comparisionData.length >= 3) {
    setErrorMsg("You can compare a maximum of 2 competitors.");
    return;
  }

  try {
    const response = await brandDataService.getCompareBrandAddOn(selectedRefId, dayRange);
    if (response.status === gtUtil.Constants.SUCCESS) {
      const newItem = response.data.rows;
      if (newItem) {
        setComparisionData(prev => [...prev, newItem]);
        setErrorMsg(null);
      } else {
        setErrorMsg("Failed to retrieve brand data.");
      }
    } else {
      setErrorMsg("Error fetching brand comparison data.");
    }
  } catch (err: any) {
    console.error("Add competitor error:", err);
    setErrorMsg("An unexpected error occurred.");
  }
};


const handleClose = (ref_id: string) => {
  setComparisionData(prev => prev.filter(item => item.ref_id !== ref_id));
};


// DUMMY DATA FOR BRAND PROFILE
const brandProfile = {
    name: "Mamaearth",
    username: "mamaearth",
    image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=200",
    followers: "2.1M",
    posts: 156,
    images: 842,
    videos: 94,
  };

  // Budget Data
  const budgetData = {
    monthly: "₹75,000",
    annually: "₹9,00,000",
  };

  // Engagement Metrics Data
  const engagementMetrics = {
    totalViews: "45M",
    avgViews: "28.8K",
    totalLikes: "3.2M",
    avgLikes: "2.1K",
    totalComments: "425K",
    avgComments: "272",
  };

  // Paid vs Organic Comparison
  const paidOrganicComparison = [
    { category: "Overall ER", paid: 5.8, organic: 4.2 },
    { category: "Static ER", paid: 5.2, organic: 3.8 },
    { category: "Video ER", paid: 7.4, organic: 5.6 },
    { category: "Post Frequency", paid: 12, organic: 18 },
  ];

  // Follower Growth Data
  const followerGrowthData = [
    { month: "Jan", followers: 1.2 },
    { month: "Feb", followers: 1.4 },
    { month: "Mar", followers: 1.6 },
    { month: "Apr", followers: 1.75 },
    { month: "May", followers: 1.95 },
    { month: "Jun", followers: 2.1 },
  ];

  // Content Type Over Time
  const contentTypeData = [
    { month: "Jan", paid: 8, organic: 15 },
    { month: "Feb", paid: 10, organic: 16 },
    { month: "Mar", paid: 9, organic: 18 },
    { month: "Apr", paid: 12, organic: 17 },
    { month: "May", paid: 14, organic: 19 },
    { month: "Jun", paid: 12, organic: 18 },
  ];

  // Posts ER Comparison Over Time
  const postsERData = [
    { month: "Jan", paid: 5.2, organic: 3.8, brand: 4.5 },
    { month: "Feb", paid: 5.5, organic: 4.0, brand: 4.7 },
    { month: "Mar", paid: 5.8, organic: 4.2, brand: 4.9 },
    { month: "Apr", paid: 6.0, organic: 4.5, brand: 5.1 },
    { month: "May", paid: 6.2, organic: 4.7, brand: 5.3 },
    { month: "Jun", paid: 5.8, organic: 4.2, brand: 5.0 },
  ];

  // Influencer Engagement Data
  const influencerTiers = [
    {
      tier: "Nano (1K-10K)",
      influencers: 45,
      posts: 120,
      er: "7.2%",
      amount: "₹12L",
      percentage: 35,
      color: "#93C5FD",
    },
    {
      tier: "Micro (10K-100K)",
      influencers: 28,
      posts: 85,
      er: "5.8%",
      amount: "₹45L",
      percentage: 30,
      color: "#C084FC",
    },
    {
      tier: "Macro (100K-1M)",
      influencers: 12,
      posts: 42,
      er: "4.2%",
      amount: "₹1.2Cr",
      percentage: 25,
      color: "#FBBF24",
    },
    {
      tier: "Mega (1M+)",
      influencers: 3,
      posts: 15,
      er: "3.5%",
      amount: "₹2.5Cr",
      percentage: 10,
      color: "#F87171",
    },
  ];

  const erOverTimeData = [
    { month: "Jan", nano: 7.0, micro: 5.5, macro: 4.0, mega: 3.2 },
    { month: "Feb", nano: 7.2, micro: 5.7, macro: 4.1, mega: 3.4 },
    { month: "Mar", nano: 7.5, micro: 5.9, macro: 4.3, mega: 3.5 },
    { month: "Apr", nano: 7.3, micro: 5.8, macro: 4.2, mega: 3.6 },
    { month: "May", nano: 7.6, micro: 6.0, macro: 4.4, mega: 3.7 },
    { month: "Jun", nano: 7.2, micro: 5.8, macro: 4.2, mega: 3.5 },
  ];

  const influencerInsights = [
    "Nano influencers achieved the highest engagement rate at 7.2%, significantly outperforming other tiers",
    "Mega influencers consumed 58% of the total budget (₹2.5Cr) but delivered the lowest ER at 3.5%",
    "Micro influencers provided the best ROI with balanced reach and engagement",
    "Total of 88 influencers engaged across all tiers with 262 posts published",
  ];

  // Engagement Snapshot Data
  const paidInfluencersData = {
    insights: [
      "Video content outperformed static posts with 7.4% ER vs 5.2% ER",
      "Top performing post achieved 12.5% ER with 285K likes",
      "Sarah Johnson's content had the highest engagement rate at 8.2%",
      "Average amount spent per post: ₹1,25,000",
    ],
    posts: [
      {
        id: "1",
        image: "https://images.unsplash.com/photo-1649589244330-09ca58e4fa64?w=100",
        caption: "Amazing skincare routine! Loving these natural products 🌿",
        username: "sarahjohnson",
        er: "8.2%",
        likes: "285K",
        comments: "12.5K",
        views: "1.2M",
        spent: "₹2,50,000",
        type: "video" as const,
      },
      {
        id: "2",
        image: "https://images.unsplash.com/photo-1624835589323-442670703bc0?w=100",
        caption: "My daily beauty essentials from @mamaearth ✨",
        username: "mikechen",
        er: "6.8%",
        likes: "210K",
        comments: "9.8K",
        views: "950K",
        spent: "₹1,80,000",
        type: "static" as const,
      },
      {
        id: "3",
        image: "https://images.unsplash.com/photo-1622236297949-eb7f7aa3a3cc?w=100",
        caption: "Toxin-free beauty is the way to go! Full review in bio 💚",
        username: "beautybyemma",
        er: "7.5%",
        likes: "340K",
        comments: "15.2K",
        views: "1.5M",
        spent: "₹3,20,000",
        type: "video" as const,
      },
    ],
    influencers: [
      {
        name: "Sarah Johnson",
        image: "https://images.unsplash.com/photo-1649589244330-09ca58e4fa64?w=100",
        followers: "450K",
        posts: 24,
        er: "8.2%",
        likes: "285K",
        comments: "12.5K",
        views: "1.2M",
        spent: "₹15,00,000",
      },
      {
        name: "Mike Chen",
        image: "https://images.unsplash.com/photo-1624835589323-442670703bc0?w=100",
        followers: "380K",
        posts: 18,
        er: "6.8%",
        likes: "210K",
        comments: "9.8K",
        views: "950K",
        spent: "₹12,00,000",
      },
    ],
  };

  const organicInfluencersData = {
    insights: [
      "Organic posts maintain 4.2% average ER without paid promotion",
      "User-generated content shows 22% higher authenticity scores",
      "Tagged posts reach 18% more audience organically",
      "Static images dominate organic content at 65%",
    ],
    posts: [
      {
        id: "1",
        image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
        caption: "Obsessed with this natural glow! #mamaearth #organicskincare",
        username: "alexthompson",
        er: "5.2%",
        likes: "125K",
        comments: "5.2K",
        views: "580K",
        type: "static" as const,
      },
      {
        id: "2",
        image: "https://images.unsplash.com/photo-1649589244330-09ca58e4fa64?w=100",
        caption: "Best natural products I've tried! Highly recommend 🌱",
        username: "beautylover23",
        er: "4.8%",
        likes: "98K",
        comments: "4.5K",
        views: "450K",
        type: "video" as const,
      },
    ],
    influencers: [
      {
        name: "Alex Thompson",
        image: "https://images.unsplash.com/photo-1624835589323-442670703bc0?w=100",
        followers: "280K",
        posts: 16,
        er: "5.9%",
        likes: "165K",
        comments: "7.2K",
        views: "720K",
        spent: "₹0",
      },
    ],
  };

  const brandPostsData = {
    insights: [
      "Brand's own posts achieve 5.0% average ER",
      "Product launch videos perform 35% better than regular posts",
      "Behind-the-scenes content drives highest comment engagement",
      "Carousel posts have 28% higher save rate",
    ],
    posts: [
      {
        id: "1",
        image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
        caption: "Introducing our new toxin-free skincare range! 🌿✨",
        username: "mamaearth",
        er: "5.8%",
        likes: "185K",
        comments: "8.5K",
        views: "820K",
        type: "video" as const,
      },
    ],
    influencers: [
      {
        name: "Mamaearth Official",
        image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
        followers: "2.1M",
        posts: 156,
        er: "5.0%",
        likes: "8.5M",
        comments: "425K",
        views: "45M",
        spent: "₹0",
      },
    ],
  };

  // Sentiment Analysis Data
  const paidSentimentData = {
    positive: 72,
    neutral: 21,
    negative: 7,
  };

  const organicSentimentData = {
    positive: 65,
    neutral: 27,
    negative: 8,
  };

  const paidPositiveComments = [
    "Amazing quality and fast delivery!",
    "Highly recommend! Exceeded expectations!",
    "Exactly what I was looking for. Very satisfied!",
    "Great results! Will definitely buy again.",
  ];

  const organicPositiveComments = [
    "Love this brand! Been using for months now.",
    "Natural ingredients really show in the results!",
    "Best decision I made for my skincare routine.",
    "Absolutely worth every rupee spent!",
  ];

  // Hashtags Data
  const hashtagsData = [
    { tag: "#brandname", uses: "582", er: "9.2% ER" },
    { tag: "#campaign2024", uses: "456", er: "8.8% ER" },
    { tag: "#newlaunch", uses: "389", er: "10.1% ER" },
    { tag: "#trending", uses: "312", er: "7.5% ER" },
    { tag: "#lifestyle", uses: "298", er: "8.3% ER" },
    { tag: "#fashion", uses: "276", er: "9% ER" },
    { tag: "#beauty", uses: "245", er: "8.7% ER" },
    { tag: "#tech", uses: "198", er: "7.9% ER" },
  ];

  // Similar Accounts Data
  const similarAccounts = [
    {
      name: "The Body Shop",
      username: "thebodyshop",
      image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
      followers: "3.2M",
      posts: 2845,
    },
    {
      name: "Lush Cosmetics",
      username: "lush",
      image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
      followers: "4.1M",
      posts: 3124,
    },
    {
      name: "Plum Goodness",
      username: "plumgoodness",
      image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
      followers: "850K",
      posts: 1256,
    },
    {
      name: "Forest Essentials",
      username: "forestessentialsindia",
      image: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=100",
      followers: "625K",
      posts: 982,
    },
  ];

  // Top Performers Data
  const topPaidInfluencers = [
    {
      id: "1",
      name: "Priya Sharma",
      username: "priyasharma",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100",
      metric1: "8.4%",
      metric1Label: "ER",
      metric2: "12",
      metric2Label: "posts",
    },
    {
      id: "2",
      name: "Anjali Verma",
      username: "anjaliverma",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100",
      metric1: "7.9%",
      metric1Label: "ER",
      metric2: "10",
      metric2Label: "posts",
    },
    {
      id: "3",
      name: "Neha Kapoor",
      username: "nehakapoor",
      avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100",
      metric1: "7.6%",
      metric1Label: "ER",
      metric2: "9",
      metric2Label: "posts",
    },
    {
      id: "4",
      name: "Radhika Singh",
      username: "radhikasingh",
      avatar: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=100",
      metric1: "7.2%",
      metric1Label: "ER",
      metric2: "8",
      metric2Label: "posts",
    },
    {
      id: "5",
      name: "Simran Malhotra",
      username: "simranmalhotra",
      avatar: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=100",
      metric1: "6.8%",
      metric1Label: "ER",
      metric2: "7",
      metric2Label: "posts",
    },
  ];

  const topOrganicInfluencers = [
    {
      id: "1",
      name: "Riya Patel",
      username: "riyapatel",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100",
      metric1: "9.2%",
      metric1Label: "ER",
      metric2: "18",
      metric2Label: "mentions",
    },
    {
      id: "2",
      name: "Kavya Reddy",
      username: "kavyareddy",
      avatar: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=100",
      metric1: "8.5%",
      metric1Label: "ER",
      metric2: "15",
      metric2Label: "mentions",
    },
    {
      id: "3",
      name: "Isha Gupta",
      username: "ishagupta",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100",
      metric1: "8.1%",
      metric1Label: "ER",
      metric2: "14",
      metric2Label: "mentions",
    },
    {
      id: "4",
      name: "Divya Menon",
      username: "divyamenon",
      avatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100",
      metric1: "7.8%",
      metric1Label: "ER",
      metric2: "12",
      metric2Label: "mentions",
    },
    {
      id: "5",
      name: "Meera Joshi",
      username: "meerajoshi",
      avatar: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100",
      metric1: "7.4%",
      metric1Label: "ER",
      metric2: "11",
      metric2Label: "mentions",
    },
  ];

  const topCompetition = [
    {
      id: "1",
      name: "Plum",
      username: "plumgoodness",
      avatar: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=100",
      metric1: "850K",
      metric1Label: "followers",
      metric2: "4.9%",
      metric2Label: "ER",
    },
    {
      id: "2",
      name: "WOW Skin Science",
      username: "wowskinscienceindia",
      avatar: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=100",
      metric1: "1.2M",
      metric1Label: "followers",
      metric2: "5.2%",
      metric2Label: "ER",
    },
    {
      id: "3",
      name: "Biotique",
      username: "biotiqueindia",
      avatar: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=100",
      metric1: "950K",
      metric1Label: "followers",
      metric2: "4.5%",
      metric2Label: "ER",
    },
    {
      id: "4",
      name: "mCaffeine",
      username: "mcaffeine",
      avatar: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=100",
      metric1: "680K",
      metric1Label: "followers",
      metric2: "4.2%",
      metric2Label: "ER",
    },
    {
      id: "5",
      name: "Forest Essentials",
      username: "forestessentialsindia",
      avatar: "https://images.unsplash.com/photo-1574282765723-4bcc6582d8b8?w=100",
      metric1: "520K",
      metric1Label: "followers",
      metric2: "3.8%",
      metric2Label: "ER",
    },
  ];

  // Competition Analysis Data
  // Self Brand
  const selfBrand = {
    id: "mamaearth",
    name: "Mamaearth",
    username: "mamaearth",
    logo: "https://images.unsplash.com/photo-1759563874711-b026ac0b6c6e?w=200",
    followers: "2.1M",
    followerCount: 2100000,
    postFrequency: 26,
    erOverall: 5.8,
    erPaid: 6.2,
    erOrganic: 4.2,
    budgetMonthly: "₹75,000",
    budgetAnnually: "₹9,00,000",
    influencerTiers: [
      { tier: "Nano", percentage: 35, color: "#93C5FD" },
      { tier: "Micro", percentage: 28, color: "#C084FC" },
      { tier: "Macro", percentage: 22, color: "#86EFAC" },
      { tier: "Mega", percentage: 15, color: "#FBBF24" },
    ],
    isSelf: true,
    monthlyGrowthRate: 3.2,
    avgCommentsPerPost: 1245,
    reelsER: 7.8,
    followerGrowth30Days: "+68K",
    reelsVsPostsRatio: "60:40",
    videoERvsStaticER: "7.4% vs 5.2%",
    postingConsistencyScore: 8.5,
    influencerCollabCount: 88,
    brandSentimentScore: 8.2,
  };

  // Available Competitor Brands
  const availableCompetitorBrands = [
    {
      id: "plum",
      name: "Plum",
      username: "plumgoodness",
      logo: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=200",
      followers: "850K",
      followerCount: 850000,
      postFrequency: 22,
      erOverall: 4.9,
      erPaid: 5.4,
      erOrganic: 3.8,
      budgetMonthly: "₹62,000",
      budgetAnnually: "₹7,44,000",
      influencerTiers: [
        { tier: "Nano", percentage: 42, color: "#93C5FD" },
        { tier: "Micro", percentage: 31, color: "#C084FC" },
        { tier: "Macro", percentage: 18, color: "#86EFAC" },
        { tier: "Mega", percentage: 9, color: "#FBBF24" },
      ],
      monthlyGrowthRate: 2.8,
      avgCommentsPerPost: 895,
      reelsER: 6.9,
      followerGrowth30Days: "+42K",
      reelsVsPostsRatio: "55:45",
      videoERvsStaticER: "6.5% vs 4.8%",
      postingConsistencyScore: 7.8,
      influencerCollabCount: 72,
      brandSentimentScore: 7.6,
    },
    {
      id: "wowskin",
      name: "WOW Skin Science",
      username: "wowskinscienceindia",
      logo: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=200",
      followers: "1.2M",
      followerCount: 1200000,
      postFrequency: 24,
      erOverall: 5.2,
      erPaid: 5.8,
      erOrganic: 4.0,
      budgetMonthly: "₹68,000",
      budgetAnnually: "₹8,16,000",
      influencerTiers: [
        { tier: "Nano", percentage: 38, color: "#93C5FD" },
        { tier: "Micro", percentage: 30, color: "#C084FC" },
        { tier: "Macro", percentage: 20, color: "#86EFAC" },
        { tier: "Mega", percentage: 12, color: "#FBBF24" },
      ],
      monthlyGrowthRate: 3.5,
      avgCommentsPerPost: 1156,
      reelsER: 7.2,
      followerGrowth30Days: "+58K",
      reelsVsPostsRatio: "58:42",
      videoERvsStaticER: "6.8% vs 5.0%",
      postingConsistencyScore: 8.2,
      influencerCollabCount: 85,
      brandSentimentScore: 7.9,
    },
    {
      id: "mcaffeine",
      name: "mCaffeine",
      username: "mcaffeine",
      logo: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=200",
      followers: "680K",
      followerCount: 680000,
      postFrequency: 18,
      erOverall: 4.2,
      erPaid: 4.8,
      erOrganic: 3.2,
      budgetMonthly: "₹55,000",
      budgetAnnually: "₹6,60,000",
      influencerTiers: [
        { tier: "Nano", percentage: 48, color: "#93C5FD" },
        { tier: "Micro", percentage: 32, color: "#C084FC" },
        { tier: "Macro", percentage: 14, color: "#86EFAC" },
        { tier: "Mega", percentage: 6, color: "#FBBF24" },
      ],
      monthlyGrowthRate: 2.1,
      avgCommentsPerPost: 742,
      reelsER: 6.2,
      followerGrowth30Days: "+35K",
      reelsVsPostsRatio: "52:48",
      videoERvsStaticER: "5.9% vs 4.2%",
      postingConsistencyScore: 7.2,
      influencerCollabCount: 62,
      brandSentimentScore: 7.1,
    },
    {
      id: "biotique",
      name: "Biotique",
      username: "biotiqueindia",
      logo: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=200",
      followers: "950K",
      followerCount: 950000,
      postFrequency: 20,
      erOverall: 4.5,
      erPaid: 5.0,
      erOrganic: 3.5,
      budgetMonthly: "₹60,000",
      budgetAnnually: "₹7,20,000",
      influencerTiers: [
        { tier: "Nano", percentage: 40, color: "#93C5FD" },
        { tier: "Micro", percentage: 33, color: "#C084FC" },
        { tier: "Macro", percentage: 17, color: "#86EFAC" },
        { tier: "Mega", percentage: 10, color: "#FBBF24" },
      ],
      monthlyGrowthRate: 2.5,
      avgCommentsPerPost: 968,
      reelsER: 6.5,
      followerGrowth30Days: "+48K",
      reelsVsPostsRatio: "50:50",
      videoERvsStaticER: "6.2% vs 4.5%",
      postingConsistencyScore: 7.5,
      influencerCollabCount: 68,
      brandSentimentScore: 7.3,
    },
    {
      id: "forestessentials",
      name: "Forest Essentials",
      username: "forestessentialsindia",
      logo: "https://images.unsplash.com/photo-1574282765723-4bcc6582d8b8?w=200",
      followers: "520K",
      followerCount: 520000,
      postFrequency: 16,
      erOverall: 3.8,
      erPaid: 4.2,
      erOrganic: 2.9,
      budgetMonthly: "₹48,000",
      budgetAnnually: "₹5,76,000",
      influencerTiers: [
        { tier: "Nano", percentage: 35, color: "#93C5FD" },
        { tier: "Micro", percentage: 25, color: "#C084FC" },
        { tier: "Macro", percentage: 25, color: "#86EFAC" },
        { tier: "Mega", percentage: 15, color: "#FBBF24" },
      ],
      monthlyGrowthRate: 1.8,
      avgCommentsPerPost: 652,
      reelsER: 5.5,
      followerGrowth30Days: "+28K",
      reelsVsPostsRatio: "48:52",
      videoERvsStaticER: "5.2% vs 3.8%",
      postingConsistencyScore: 6.8,
      influencerCollabCount: 54,
      brandSentimentScore: 6.9,
    },
  ];

const hasPaidComments = Array.isArray(paidComments) && paidComments.length > 0;
const hasOrganicComments = Array.isArray(organicComments) && organicComments.length > 0;

  return (
    <>
    
      {userStatus && <div className='d-flex justify-content-center align-items-center brand-pulse'>                                                            
        {/* .....................For Search Bar................................... */}
        <div className='container custom-container position-relative'>
        {showSearchBar && (
  <>
    {/* <span onClick={handleSearchExpand} className='search-expand'>
      <MaterialSymbol iconName='search' fontweight='200' />
    </span> */}

    <div className="search-container-content">
      <InstagramIcon className="search-plt-type-icon icon-instagram" width={20} height={20} />
      <form className="d-flex">
        <input
          type="search"
          placeholder="Search by name or username"
          className="form-control"
          id="brand-search-by-name"
          onChange={handleSearchBar}
          onClick={() => setIsSelected(true)}
          value={searchValue}
        />
        <button
          type="button"
          className="btn d-flex btn-search"
          onMouseDown={(e) => e.preventDefault()}
        >
          <Search />
        </button>
      </form>
      {searchList.length > 0 && isSelected && (
        <div className="search-suggestion" style={{ cursor: 'pointer' }}>
          <ul>
            {searchList.slice(0, 10).map((item: any) => renderProfileListItem(item))}
          </ul>
        </div>
      )}
    </div>
  </>
)}
        
        </div>
        {/* .....................End of Search Bar................................... */}

      </div>
      }
      
      {brandRefId &&
        <div className='container-analytics mx-auto'>
          <Tab.Container defaultActiveKey="brand_pulse">
            <div className=''>
              <Nav variant="pills" className="d-flex brand-pulse-tab mb-2">
                <Nav.Item>
                  <Nav.Link eventKey="brand_pulse" className=''>Brand Pulse</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="analytics"  className='' disabled={linkedCampaignId.length > 0 ? false : true}>Campaign Tracking</Nav.Link>
                </Nav.Item>
                {/* Only while nothing is tracked yet - once a campaign exists the Campaign
                    Tracking tab is enabled and this shortcut has nothing left to do. */}
                {linkedCampaignId.length === 0 && (
                  <MuiTooltip title='Create Campaign' arrow placement='top'>
                    <button
                      type='button'
                      // no `btn` class: Bootstrap's .btn sets its own padding/line-height at the
                      // same specificity, which would fight the metrics that match the pills
                      className='create-campaign-icon-btn'
                      aria-label='Create Campaign'
                      onClick={() => setOpenCreateCampaign(true)}
                    >
                      {/* `1em` so the glyph tracks the nav font size and the circle keeps the pill's height */}
                      <MaterialSymbol iconName='add' fontweight='200' fontSize='1em' lineHeight='1' />
                    </button>
                  </MuiTooltip>
                )}
              </Nav>
            </div>
            <Tab.Content>
              <Tab.Pane eventKey="brand_pulse"><div style={{ paddingTop: '24px', paddingBottom: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <div className=''>
                  <>
                    <div className='brand-pulse-duration-select'>
                      <FormControl fullWidth>
                      <InputLabel id="select-label" sx={{ backgroundColor: 'white', px: 0.5 }}>
                        Showing data for last
                      </InputLabel>
                        <Select
                          labelId="select-label"
                          id="select"
                          value={dayRange}
                          label="Select an option"
                          onChange={handleChange}
                        >
                          <MenuItem value="7">7 Days</MenuItem>
                          <MenuItem value="15">15 Days</MenuItem>
                          <MenuItem value="30">30 Days</MenuItem>
                          <MenuItem value="90">90 Days</MenuItem>
                          <MenuItem value="180" selected>180 Days</MenuItem>
                          <MenuItem value="365" disabled> 1 year</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    {hasSearched &&<BrandPulseProfileCard loader={
                      profileLoading} profileData={profileData} />}
                    </>
                
                  <>
                  
                  {(brandPulseLoading || Object.keys(dataApi2).length > 0) && <MetricsCard profileEr={profileEr} postFrequency={postFrequency} paidFrequency={paidFrequency} organicFrequency={organicFrequency} paidOrganicEr={paidOrganicER} budget={amount} paidOrganicImageVideoER={paidOrganicImageVideoER} loader={loadingMetricCard || Object.keys(dataApi2).length === 0} dayRange = {dayRange}/>}
                    <Grid container spacing={2} className="mt-2 mb-3">
                    {(brandPulseLoading || Object.keys(dataApi6).length > 0) && (
                      <>
                        <Grid item xs={12} md={6} lg={4}>
                          <FollowersGrowthChart loader={loadingGrowthChart || Object.keys(dataApi6).length === 0} subsGrowthStockChartData={subsGrowthStockChartData} />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4}>
                          <ContentTypeChart loader={loadingGrowthChart || Object.keys(dataApi6).length === 0} subsGrowthStockChartData={contentTypeChart} />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4}>
                          <PostErChart postErChart={postErChart} loader={loadingGrowthChart || Object.keys(dataApi6).length === 0} />
                        </Grid>
                      </>
                    )}
                    </Grid>
                    <Grid container spacing={2} className="mb-3">
                      {Object?.keys(dataApi3).length > 0 ?
                        <Grid item xs={12} sm={12} md={12}>
                          <TopInfluencer topPaidInfluencer={topPaidInfluencer} topOrganicInfluencer={topOrganicInfluencer} topCompetitors={topCompetitors} />
                        </Grid>
                       : brandPulseLoading &&
                        <Grid item xs={12} sm={12} md={12}><SectionSkeleton height={170} className="" /></Grid>
                      }
                    </Grid>
                    <Grid container spacing={2} className="mb-3">
                      {(emvGraph.length > 0 || amountGraph.length > 0) ? (
                        <>
                          {emvGraph.length > 0  && (
                            <Grid item xs={12} sm={12} md={6}>
                              <EmvChart emvGrowthChart={emvGraph} />
                            </Grid>
                          )}
                          {(amountGraph.length > 0) &&
                            <Grid item xs={12} sm={12} md={6}>
                              <EmvROI amountGraph={amountGraph} />
                            </Grid>
                          }
                        </>
                      ) : brandPulseLoading && (
                        <>
                          <Grid item xs={12} sm={12} md={6}><SectionSkeleton height={300} className="" /></Grid>
                          <Grid item xs={12} sm={12} md={6}><SectionSkeleton height={300} className="" /></Grid>
                        </>
                      )}
                    </Grid>

                    {influencerEngagementSummaryPaid.length > 0 ?
                      <Grid item xs={12} sm={12} md={12} className='mb-3'>
                        <section className="brand-insight-highchart">
                          <div className="brand-insight-highchart-top">
                            <strong className="brand-insight-highchart-title d-flex flex-column">
                              Influencer Engagement Summary
                            </strong>
                          </div>
                          <div className="brand-insight-highchart-data">
                            <Grid container spacing={2} className="mt-2">
                              <Grid item xs={12} md={12} lg={8} xl={8}>
                                <strong>Key Insights:</strong>
                                <ul className='key-insight-list'>
                                  {Object.entries(metricConfig).map(([metric, config]) => {
                                    const filtered = keyInsightsPaid.filter(item => item.metric === metric);
                                    if (!filtered.length) return null;

                                    const maxValue = Math.max(...filtered.map(item => item.MAX_VALUE));
                                    const topItems = filtered.filter(item => item.MAX_VALUE === maxValue);
                                    const influencerTypes = getInfluencerTypesWithRange(topItems);

                                    return (
                                      <li key={metric}>
                                        {config.icon} <span>{config.label}</span> : {config.template(influencerTypes, maxValue)}
                                      </li>
                                    );
                                  })}                                 
                                </ul>
                              </Grid>
                              <>
                                <Grid className='' item xs={12} md={12} lg={4} xl={4}>
                                  <EngagedInfluencers data={influencerEngagementSummaryPaid} />

                                </Grid>
                                <Grid item xs={12} md={12} lg={4} xl={4} className="">
                                  <EngagedInfluencersAmount data={influencerEngagementSummaryPaid} />

                                </Grid>
                              </>
                              {influencerEngagementGraphOrganic.length > 0 && <Grid item xs={12} md={12} lg={8} xl={8} >
                                <div className="infl-engg-er infl-engg-common-bg">
                                  <div className="d-flex flex-column">
                                    <span className="infl-engg-ratio-title" >Engagement Rate </span> <BrandErVerticalChart erOrganic ={influencerEngagementGraphOrganic} />
                                  </div>
                                </div>
                              </Grid>
                              }
                              <Grid columns={10} container spacing={2} className="mt-2 ms-0">
                              <Grid item xs={12} md={2} lg={2} xl={2}>
                                <div className='engagement-detail'>
                                  <span>No. of Influencers</span>
                                  <strong>{totalFollowers}</strong>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={2} lg={2} xl={2}>
                                <div className='engagement-detail'>
                                  <span>Total Posts Created</span>
                                  <strong>{totalPosts}</strong>
                                </div>
                              </Grid>
                              
                              <Grid item xs={12} md={2} lg={2} xl={2}>
                                <div className='engagement-detail'>
                                  <span>Overall Engagement Rate</span>
                                  <strong>{totalER?.toFixed(2)}%</strong>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={2} lg={2} xl={2}>
                                <div className='engagement-detail'>
                                  <span>Amount Spent</span>
                                  <strong>{methods.convertExactNumber(totalAmountSpent)}</strong>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={2} lg={2} xl={2}>
                                <div className='engagement-detail'>
                                  <span>Earned Media Value (EMV)</span>
                                  <strong>
                                    {methods.convertExactNumber(totalEMV)}</strong>
                                </div>
                              </Grid>
                              </Grid>

                              <Grid item xs={12} md={12} lg={12} xl={12}>
                                <EngagedInfluencerTable type={influencerEngagementSummaryPaid[0].paid_type} detailedInfluencer={influencerEngagementSummaryPaid} />
                              </Grid>
                            </Grid>

                          </div>
                        </section>
                      </Grid>
                     : brandPulseLoading && <SectionSkeleton height={350} />
              }

              {/* {detailedInfluencer.length > 0 && <DetailedInfluencerAnalytics detailedInfluencer={detailedInfluencer} />} */}
              <Grid container spacing={3} className="mb-3">
               {/* ===== COMMENTS ROW ===== */}
  {(brandPulseLoading && !(Object?.keys(dataApi4)?.length > 0)) ? (
    <Grid item xs={12} md={6}><SectionSkeleton height={260} className="" /></Grid>
  ) : Object?.keys(dataApi4)?.length > 0 && (
    <>
      {hasPaidComments && (
        <Grid item xs={12} md={hasOrganicComments ? 6 : 6}>
          <CommentsTab
            title="Comment Analysis - Paid"
            comments={paidComments}
            totalCommentsCount={totalCommentsCount}
          />
        </Grid>
      )}

      {hasOrganicComments && (
        <Grid item xs={12} md={hasPaidComments ? 6 : 6}>
          <CommentsTab
            title="Comment Analysis - Organic"
            comments={organicComments}
            totalCommentsCount={totalCommentsCount}
          />
        </Grid>
      )}
    </>
  )}

  {/* ===== HASHTAGS ROW ===== */}
  {(brandPulseLoading && !(Object?.keys(dataApi5)?.length > 0)) ? (
    <Grid item xs={12} md={6}><SectionSkeleton height={260} className="" /></Grid>
  ) : Object?.keys(dataApi5)?.length > 0 && (
    <>
      {paidHashtags?.length > 0 && (
        <Grid item xs={12} md={organicHashtags?.length ? 6 : 6}>
          <WordCloudComponent
            words={paidHashtags}
            componentName="Paid Hashtags"
          />
        </Grid>
      )}

      {organicHashtags?.length > 0 && (
        <Grid item xs={12} md={paidHashtags?.length ? 6 : 6}>
          <WordCloudComponent
            words={organicHashtags}
            componentName="Organic Hashtags"
          />
        </Grid>
      )}
    </>
  )}

              </Grid>
              {/* <DetailedInfluencerAnalytics
              title="Paid Influencer Engagement Snapshot"
                detailedInfluencer={detailedInfluencerTableData}
                onTabSelect={handleTabSelect}
              />

              <DetailedInfluencerAnalytics
              title="Organic Influencer Engagement Snapshot"
                detailedInfluencer={detailedInfluencerTableData}
                onTabSelect={handleTabSelect}
              />

              <DetailedInfluencerAnalytics 
              title="All Influencer Engagement Snapshot"
                detailedInfluencer={detailedInfluencerTableData}
                onTabSelect={handleTabSelect}
              /> */}
              {brandPulseLoading ? <SectionSkeleton height={400} /> : (
              <section className="brand-insight-highchart">
                <div className="brand-insight-highchart-top">
                  <strong className="brand-insight-highchart-title d-flex flex-column">
                      Engagement Snapshot
                  </strong>
                </div>
                  <div className={`brand-pulse-influencer-details-table mb-3`}>
                    
                      <div className='engg-snapshot-data brand-insight-highchart-data px-0'>
                      <Tab.Container
                        defaultActiveKey="paid"
                        onSelect={async (eventKey) => {
                          let newAccordion:any;
                          if (eventKey === activeAccordion) {
                            newAccordion = undefined;
                          } else {
                            newAccordion = eventKey === "paid" ? "paid" : eventKey === "organic" ? "brand_organic" : "brand";
                          }

                          setActiveAccordion(newAccordion);

                          if (newAccordion !== undefined) {
                            const mediaType = selectedTab === 'influencer' ? 'influencer' : 'brands';
                            const contentType = selectedInnerTab === 'image' ? 'image' : 'video';

                            try {
                              setLoadingAccordion(true);
                              const day_range:any = profileUpdatedAt ? Number(dayRange) + profileUpdatedAt : Number(dayRange) + 0
                              await influencerBrandData(brandRefId, selectedTab, selectedInnerTab, newAccordion, day_range);
                            } catch (error) {
                              console.error("Error fetching data for brand accordion:", error);
                            } finally {
                              setLoadingAccordion(false);
                            }
                          }
                        }}
                      >
                        <Nav className="engg-snapshot-data-tab">
                          <Nav.Item>
                            <Nav.Link eventKey="paid">Paid Influencers</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="organic">Organic/ Tagged Influencers</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="brand">Brand's Own Posts</Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <Tab.Content className='engg-snapshot-data-tab-content'>
                          <Tab.Pane eventKey="paid"> 
                            
                          <DetailedInfluencerAnalyticsPaid loader={loadingAccordion} title='Paid Influencer Engagement Snapshot' noData={detailedInfluencerTableData?.paid_noData}
                            detailedInfluencer={detailedInfluencerTableData?.paid}
                            onTabSelect={handleTabSelect}
                            isOpen={activeAccordion === 'paid'}
                            insight={EnggSnapshotData || {}}  
                          />
                            
                        </Tab.Pane>
                          <Tab.Pane eventKey="organic">
                          <DetailedInfluencerAnalyticsBrandOrganic noData={detailedInfluencerTableData.brand_organic_noData}
                            detailedInfluencer={detailedInfluencerTableData.brand_organic}
                            onTabSelect={handleTabSelect}
                            isOpen={activeAccordion === 'brand_organic'}
                            loader={loadingAccordion}
                            insight={EnggSnapshotData}
                          />
                          </Tab.Pane>
                          <Tab.Pane eventKey="brand">
                          <DetailedInfluencerAnalyticsBrand
                            title='All Influencer Engagement Snapshot'
                            detailedInfluencer={detailedInfluencerTableData.brand}
                            noData={detailedInfluencerTableData.brand_noData}
                            onTabSelect={handleTabSelect}
                            isOpen={activeAccordion === 'brand'}
                            loader={loadingAccordion}
                            insight={EnggSnapshotData}
                            
                          />
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                      </div>
                  </div>
              </section>
              )}

                    {brandData?.length > 0 && influencerData?.length > 0 &&
                      <div className='similar-brand-container'>
                        <Tab.Container defaultActiveKey="brands">
                          <Nav className='similar-brand-tab' onSelect={handleSelect}>
                            <Nav.Item>
                              <Nav.Link eventKey="brands" className='detailed-infl-tab'>Brands</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="influencer" className='detailed-infl-tab'>Influencers</Nav.Link>
                            </Nav.Item>
                          </Nav>
                          <Tab.Content>
                            <Tab.Pane eventKey="brands">
                              {brandData.length > 0 && <InfluencerGrid title="Similar Accounts" influencerData={brandData} />}
                            </Tab.Pane>

                            <Tab.Pane eventKey="influencer">
                              {influencerData.length > 0 && <InfluencerGrid title="Similar Accounts" influencerData={influencerData} />}
                            </Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      </div>
                    }
                    {(comparisionData.length > 0 && brandData.length > 0) ? <ComparisionTable handleClose={handleClose} handleAddCompetitorComparison={handleAddCompetitorComparison} error={errorMsg} data={comparisionData} brandData ={brandData} /> : brandPulseLoading && <SectionSkeleton height={400} />}
                  </>
              </div>
            </div></Tab.Pane>
              <Tab.Pane eventKey="analytics"><BrandPulseCampaignList linkedCampaignId={linkedCampaignId} loader={profileLoading} profileData={profileData} onCreateCampaign={() => setOpenCreateCampaign(true)} onCampaignDeleted={() => refreshLinkedCampaigns(brandRefId)} />

                </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      }

      {/* Mounted at the top level of the component so it is never unmounted by a tab or a
          conditional section. The popup itself renders through a portal on document.body. */}
      {openCreateCampaign && (
        <CreateBrandPulseCampaignPopup
          openModal={openCreateCampaign}
          onClose={() => setOpenCreateCampaign(false)}
          refId={brandRefId}
          // profileData is declared as useState("") but holds the brand_profile array at
          // runtime, so it has to be read through a cast here
          brandName={(profileData as any)?.[0]?.name || (profileData as any)?.[0]?.insta_name || (profileData as any)?.[0]?.username || ''}
          UserReducer={props?.UserReducer}
          onCreated={() => refreshLinkedCampaigns(brandRefId)}
        />
      )}
    </>
  )
}
const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(BrandPulse);

export { connectToRedux as BrandPulse };



